import { faCartShopping } from '@fortawesome/pro-solid-svg-icons/faCartShopping';
import { faWarehouse } from '@fortawesome/pro-solid-svg-icons/faWarehouse';
import { faPlateUtensils } from '@fortawesome/pro-solid-svg-icons/faPlateUtensils';
import { faPeopleGroup } from '@fortawesome/pro-solid-svg-icons/faPeopleGroup';
import { faContainerStorage } from '@fortawesome/pro-solid-svg-icons/faContainerStorage';
import { faPalette } from '@fortawesome/pro-solid-svg-icons/faPalette';
import { faChairOffice } from '@fortawesome/pro-solid-svg-icons/faChairOffice';
import { faChampagneGlasses } from '@fortawesome/pro-solid-svg-icons/faChampagneGlasses';
import { faUtensils } from '@fortawesome/pro-solid-svg-icons/faUtensils';
import { faMoon } from '@fortawesome/pro-solid-svg-icons/faMoon';
import { faStore } from '@fortawesome/pro-solid-svg-icons/faStore';
import { faCameraMovie } from '@fortawesome/pro-solid-svg-icons/faCameraMovie';
import { faBurgerGlass } from '@fortawesome/pro-solid-svg-icons/faBurgerGlass';
import { faBriefcase } from '@fortawesome/pro-solid-svg-icons/faBriefcase';
import { faRestroom } from '@fortawesome/pro-solid-svg-icons/faRestroom';
import { faFlowerDaffodil } from '@fortawesome/pro-solid-svg-icons/faFlowerDaffodil';
import { faWheelchair } from '@fortawesome/pro-solid-svg-icons/faWheelchair';
import { faAirConditioner } from '@fortawesome/pro-solid-svg-icons/faAirConditioner';
import { faCameraCctv } from '@fortawesome/pro-solid-svg-icons/faCameraCctv';
import { faSunBright } from '@fortawesome/pro-solid-svg-icons/faSunBright';
import { faWineBottle } from '@fortawesome/pro-solid-svg-icons/faWineBottle';
import { faClothesHanger } from '@fortawesome/pro-solid-svg-icons/faClothesHanger';
import { faHeat } from '@fortawesome/pro-solid-svg-icons/faHeat';
import { faCars } from '@fortawesome/pro-solid-svg-icons/faCars';
import { faShelvesEmpty } from '@fortawesome/pro-solid-svg-icons/faShelvesEmpty';
import { faCouch } from '@fortawesome/pro-solid-svg-icons/faCouch';
import { faPlug } from '@fortawesome/pro-solid-svg-icons/faPlug';
import { faCircleParking } from '@fortawesome/pro-solid-svg-icons/faCircleParking';
import { faDogLeashed } from '@fortawesome/pro-solid-svg-icons/faDogLeashed';
import { faComputerSpeaker } from '@fortawesome/pro-solid-svg-icons/faComputerSpeaker';
import { faPersonArrowDownToLine } from '@fortawesome/pro-solid-svg-icons/faPersonArrowDownToLine';

import { faShop } from '@fortawesome/sharp-solid-svg-icons/faShop';
import { faFerrisWheel } from '@fortawesome/sharp-solid-svg-icons/faFerrisWheel';
import { faHouseTurret } from '@fortawesome/sharp-solid-svg-icons/faHouseTurret';
import { faBuilding } from '@fortawesome/sharp-solid-svg-icons/faBuilding';
import { faHouseTree } from '@fortawesome/sharp-solid-svg-icons/faHouseTree';
import { faHouseBuilding } from '@fortawesome/sharp-solid-svg-icons/faHouseBuilding';
import { faPaintbrushPencil } from '@fortawesome/sharp-solid-svg-icons/faPaintbrushPencil';
import { faTablePicnic } from '@fortawesome/sharp-solid-svg-icons/faTablePicnic';
import { faHotel } from '@fortawesome/sharp-solid-svg-icons/faHotel';
import { faLandmark } from '@fortawesome/sharp-solid-svg-icons/faLandmark';
import { faTruckContainer } from '@fortawesome/sharp-solid-svg-icons/faTruckContainer';
import { faRectangleVerticalHistory } from '@fortawesome/sharp-solid-svg-icons/faRectangleVerticalHistory';
import { faShip } from '@fortawesome/sharp-solid-svg-icons/faShip';
import { faShirt } from '@fortawesome/sharp-solid-svg-icons/faShirt';
import { faCamera } from '@fortawesome/sharp-solid-svg-icons/faCamera';
import { faUserTieHair } from '@fortawesome/sharp-solid-svg-icons/faUserTieHair';
import { faShelves } from '@fortawesome/sharp-solid-svg-icons/faShelves';
import { faStoreLock } from '@fortawesome/sharp-solid-svg-icons/faStoreLock';
import { faRocketLaunch } from '@fortawesome/sharp-solid-svg-icons/faRocketLaunch';
import { faStreetView } from '@fortawesome/sharp-solid-svg-icons/faStreetView';
import { faLightCeiling } from '@fortawesome/sharp-solid-svg-icons/faLightCeiling';
import { faWindowFrame } from '@fortawesome/sharp-solid-svg-icons/faWindowFrame';
import { faCashRegister } from '@fortawesome/sharp-solid-svg-icons/faCashRegister';
import { faWhiskeyGlassIce } from '@fortawesome/sharp-solid-svg-icons/faWhiskeyGlassIce';
import { faDungeon } from '@fortawesome/sharp-solid-svg-icons/faDungeon';
import { faMountainSun } from '@fortawesome/sharp-solid-svg-icons/faMountainSun';
import { faSmoking } from '@fortawesome/sharp-solid-svg-icons/faSmoking';
import { faVolume } from '@fortawesome/sharp-solid-svg-icons/faVolume';
import { faIndustry } from '@fortawesome/sharp-solid-svg-icons/faIndustry';
import { faHatChef } from '@fortawesome/sharp-solid-svg-icons/faHatChef';
import { faWifi } from '@fortawesome/sharp-solid-svg-icons/faWifi';
import { faSink } from '@fortawesome/sharp-solid-svg-icons/faSink';
import { faDroplet } from '@fortawesome/sharp-solid-svg-icons/faDroplet';
import { faBellConcierge } from '@fortawesome/sharp-solid-svg-icons/faBellConcierge';
import { faCubes } from '@fortawesome/sharp-solid-svg-icons/faCubes';
import { faBoothCurtain } from '@fortawesome/sharp-solid-svg-icons/faBoothCurtain';
import { faElevator } from '@fortawesome/sharp-solid-svg-icons/faElevator';

import { faCouch as sharpCouch } from '@fortawesome/sharp-solid-svg-icons/faCouch';
import { faStore as sharpStore } from '@fortawesome/sharp-solid-svg-icons/faStore';
import { faChampagneGlasses as sharpCampagneGlass } from '@fortawesome/sharp-solid-svg-icons/faChampagneGlasses';
import { faSquare } from '@fortawesome/free-regular-svg-icons/faSquare';

export const spaceTypeIconMap = {
  'fa-sharp fa-solid fa-shop': faShop,
  'fa-sharp fa-solid fa-ferris-wheel': faFerrisWheel,
  'fa-sharp fa-solid fa-house-turret': faHouseTurret,
  'fa-sharp fa-solid fa-champagne-glasses': sharpCampagneGlass,
  'fa-sharp fa-solid fa-building': faBuilding,
  'fa-sharp fa-solid fa-house-tree': faHouseTree,
  'fa-sharp fa-solid fa-house-building': faHouseBuilding,
  'fa-sharp fa-solid fa-paintbrush-pencil': faPaintbrushPencil,
  'fa-sharp fa-solid fa-table-picnic': faTablePicnic,
  'fa-sharp fa-solid fa-hotel': faHotel,
  'fa-sharp fa-solid fa-landmark': faLandmark,
  'fa-sharp fa-solid fa-truck-container': faTruckContainer,
  'fa-sharp fa-solid fa-rectangle-vertical-history': faRectangleVerticalHistory,
  'fa-sharp fa-solid fa-ship': faShip,
  'fa-solid fa-cart-shopping': faCartShopping,
  'fa-solid fa-warehouse': faWarehouse,
  'fa-solid fa-camera-movie': faCameraMovie,
  'fa-solid fa-plate-utensils': faPlateUtensils,
  'fa-solid fa-people-group': faPeopleGroup,
  'fa-solid fa-container-storage': faContainerStorage,
  'fa-solid fa-palette': faPalette,
  'fa-solid fa-chair-office': faChairOffice,
};

export const projectTypeIconMap = {
  'fa-solid fa-plate-utensils': faPlateUtensils,
  'fa-solid fa-champagne-glasses': faChampagneGlasses,
  'fa-solid fa-utensils': faUtensils,
  'fa-solid fa-moon': faMoon,
  'fa-solid fa-chair-office': faChairOffice,
  'fa-solid fa-store': faStore,
  'fa-solid fa-camera-movie': faCameraMovie,
  'fa-solid fa-cart-shopping': faCartShopping,
  'fa-solid fa-burger-glass': faBurgerGlass,
  'fa-solid fa-palette': faPalette,
  'fa-solid fa-briefcase': faBriefcase,
  'fa-solid fa-people-group': faPeopleGroup,
  'fa-solid fa-briefcase': faBriefcase ,
  'fa-sharp fa-solid fa-shirt': faShirt,
  'fa-sharp fa-solid fa-camera': faCamera,
  'fa-sharp fa-solid fa-shop': faShop,
  'fa-sharp fa-solid fa-user-tie-hair': faUserTieHair,
  'fa-solid fa-sharp fa-store': sharpStore,
  'fa-sharp fa-solid fa-shelves': faShelves,
  'fa-sharp fa-solid fa-store-lock': faStoreLock,
  'fa-sharp fa-solid fa-shelves': faShelves,
  'fa-solid fa-sharp fa-rocket-launch': faRocketLaunch ,
  'fa-sharp fa-solid fa-building': faBuilding,
};

export const listingFeatureIconMap = {
  'fa-sharp fa-solid fa-street-view': faStreetView,
  'fa-sharp fa-solid fa-light-ceiling': faLightCeiling,
  'fa-sharp fa-solid fa-rectangle-vertical-history': faRectangleVerticalHistory,
  'fa-sharp fa-solid fa-window-frame': faWindowFrame,
  'fa-sharp fa-solid fa-cash-register': faCashRegister,
  'fa-sharp fa-solid fa-whiskey-glass-ice': faWhiskeyGlassIce,
  'fa-sharp fa-solid fa-dungeon': faDungeon,
  'fa-sharp fa-solid fa-couch': sharpCouch,
  'fa-sharp fa-solid fa-mountain-sun': faMountainSun,
  'fa-sharp fa-solid fa-smoking': faSmoking,
  'fa-sharp fa-solid fa-volume': faVolume,
  'fa-sharp fa-solid fa-industry': faIndustry,
  'fa-sharp fa-solid fa-hat-chef': faHatChef,
  'fa-sharp fa-solid fa-wifi': faWifi,
  'fa-sharp fa-solid fa-sink': faSink,
  'fa-sharp fa-solid fa-building': faBuilding,
  'fa-sharp fa-solid fa-droplet': faDroplet,
  'fa-sharp fa-solid fa-table-picnic': faTablePicnic,
  'fa-sharp fa-solid fa-bell-concierge': faBellConcierge,
  'fa-sharp fa-solid fa-cubes': faCubes,
  'fa-sharp fa-solid fa-booth-curtain': faBoothCurtain,
  'fa-sharp fa-solid fa-elevator': faElevator,

  'fa-sharp fa-regular fa-square': faSquare,

  'fa-solid fa-restroom': faRestroom,
  'fa-solid fa-flower-daffodil': faFlowerDaffodil,
  'fa-solid fa-wheelchair': faWheelchair,
  'fa-solid fa-air-conditioner': faAirConditioner,
  'fa-solid fa-camera-cctv': faCameraCctv,
  'fa-solid fa-sun-bright': faSunBright,
  'fa-solid fa-wine-bottle': faWineBottle,
  'fa-solid fa-chair-office': faChairOffice,
  'fa-solid fa-clothes-hanger': faClothesHanger,
  'fa-solid fa-heat': faHeat,
  'fa-solid fa-cars': faCars,
  'fa-solid fa-shelves-empty': faShelvesEmpty,
  'fa-solid fa-couch': faCouch,
  'fa-solid fa-plug': faPlug,
  'fa-solid fa-circle-parking': faCircleParking,
  'fa-solid fa-dog-leashed': faDogLeashed,
  'fa-solid fa-computer-speaker': faComputerSpeaker,
  'fa-solid fa-person-arrow-down-to-line': faPersonArrowDownToLine,
};
